import { IBackendServers, Languages } from '../../interfaces/common'

export const AuthBackendServers: IBackendServers = {
  [Languages.RU]: 'authBackendServerRu',
  [Languages.KZ]: 'authBackendServerKz',
  [Languages.UZ]: 'authBackendServerUz',
}
